import React from "react";
import { useDispatch } from "react-redux";

import * as ModalActions from "~/store/modules/modal/actions";
import api from "~/services/api";
import { setToken } from "~/services/token";
import definition from "~/config";

import "./Email.scss";
import ButtonSecondary from "../Button/ButtonSecondary";
import ButtonPrimary from "../Button/ButtonPrimary";
import ModalLoginError from "./ModalLoginError";

import RequestCPF from "./RequestCPF";
import { removeCharactersExceptNumbers, getCurrentDomain } from "~/utils";

export default function DocumentCode({
  companyToken,
  document: documentNumber,
  setReset,
  fetchMe,
  onHide,
  handleLoginByGuest,
}) {
  const dispatch = useDispatch();
  const [code, setCode] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const [hasRequestCPF, setHasRequestCPF] = React.useState(false);
  const [cnpjToken, setCNPJToken] = React.useState(companyToken || "");

  function handleCodeChange({ target: { value } }) {
    const parsedValue = removeCharactersExceptNumbers(value);

    setCode(parsedValue);
  }

  function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);

    const domain = getCurrentDomain();

    api
      .post(`/v1/livestreams/login`, {
        document_number: documentNumber,
        code,
        domain
      })
      .then(({ data }) => {
        const { token, has_representative } = data;

        if (has_representative) {
          setCNPJToken(token);
          setHasRequestCPF(true);
        } else {
          setToken(token);
          fetchMe();
        }
      })
      .catch((error) => {
        let errorMessage = "Não conseguimos validar seus dados de acesso, tente novamente!";

        if (error?.response?.status === 429) {
          errorMessage = "Número máximo de tentativas atingido, tente novamente em 1 minuto.";
        }

        if (error?.response?.data?.type === "ACCOUNT_CANCELLED") {
          dispatch(
            ModalActions.openModal(
              <ModalLoginError
                handleLoginByGuest={handleLoginByGuest}
                onRequestClose={() => {
                  dispatch(ModalActions.closeModal(() => {}));
                  setReset(true);
                }}
              />
            )
          );
        } else {
          alert(errorMessage);
          setReset(true);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  }

  return hasRequestCPF || companyToken ? (
    <RequestCPF companyToken={cnpjToken} onHide={onHide} />
  ) : (
    <div className="login-email">
      <div className="text">
        <h1>Autenticação</h1>
        <p>Insira seu código de verificação</p>
        {definition.accessCodeByEmail && (
          <small>O código de verificação foi enviado para o seu e-mail.</small>
        )}
      </div>

      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="code">
            Token (senha)
            <small id="input-code-description"> * Somente números</small>
          </label>
          <input
            id="code"
            name="code"
            type="number"
            inputmode="numeric" // don't have support by safari
            onChange={handleCodeChange}
            value={code}
            autoFocus
            required
          />
        </div>

        <div className="actions">
          <ButtonSecondary type="button" onClick={onHide}>
            Voltar
          </ButtonSecondary>
          <ButtonPrimary disabled={submitting}>
            {submitting ? "Aguarde..." : "OK"}
          </ButtonPrimary>
        </div>
      </form>
    </div>
  );
}
